<template>
  <div>
    <div class="infoquery">
      <banner-bg
        title="信息查询"
        subtitle="数据，让成长更有力量"
        :src="require('@/assets/images/mainindex/info-search-banner @2x.png')"
      ></banner-bg>
      <div class="infoquery_content container_wrap">
        <div class="content_tabs">
          <div
            class="content_tab"
            v-for="(item, index) in contenttabArr"
            :key="index"
            :class="item.class"
            @click="contentTabClick(index, item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="content_show">
          <div class="single_query" v-if="0">
            <img
              src="~@/assets/images/mainindex/info-search-word-cloud@2x.png"
              class="single_query_img"
            />
            <el-tabs
              v-model="singlequeryActiveName"
              @tab-click="handleSingleQueryTabClick()"
              class="eltabs"
            >
              <el-tab-pane label="姓名查询" name="姓名查询">
                <el-form
                  :model="numberValidateForm"
                  ref="numberValidateForm"
                  label-width="100px"
                  class="demo-ruleForm"
                >
                  <el-form-item
                    label="姓名"
                    prop="name"
                    :rules="[
                      {
                        required: true,
                        message: '请输入活动名称',
                        trigger: 'blur',
                      },
                      {
                        min: 2,
                        max: 50,
                        message: '长度在 2 到 50 个字符',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="numberValidateForm.name"
                      placeholder="请输入用户名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="证件号"
                    prop="inNumber"
                    :rules="[
                      {
                        type: 'number',
                        message: '请输入证件号',
                        trigger: 'blur',
                      },
                      {
                        required: true,
                        message: '证件号必须为数字值',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.inNumber"
                      autocomplete="off"
                      placeholder="请输入身份证号/护照号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="submitForm('numberValidateForm')"
                      >查询</el-button
                    >
                    <!-- <el-button @click="resetForm('numberValidateForm')">重置</el-button> -->
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="省市业务" name="省市业务"
                >省市业务</el-tab-pane
              >
            </el-tabs>
          </div>
          <div class="overall_query" v-else>
            <div class="overall_query_search">
              <el-input
                v-model="overallqueryinputdata"
                placeholder="请输入搜索内容"
                class="elinput"
              ></el-input>
              <div class="overall_query_search_but">搜索一下</div>
            </div>
            <div class="overall_query_tabs">
              <div
                class="overall_query_tab"
                v-for="(item, index) in overallquerytabsArr"
                :key="index"
                :class="item.class"
                @click="overallquerytabClick(index,item)"
              >
                {{ item.name }}({{ item.count }})
              </div>
            </div>
            <div class="overall_query_content">
              <div class="overall_query_content_list">
                  <NewsListItem :NewsItemData="[]" specialTagName="推荐"></NewsListItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerBg from "@/components/mainindex/BannerBg";
import NewsListItem from "@/components/mainindex/NewsListItem";

export default {
  name: "InfoQuery",
  data() {
    return {
      overallqueryinputdata: "",
      singlequeryActiveName: "姓名查询",
      numberValidateForm: {
        inNumber: "",
        name: "",
      },
      contenttabArr: [
        { name: "全局查询", class: "content_tab_active" },
        { name: "单位查询", class: "" },
        { name: "下载中心", class: "" },
      ],
      overallquerytabsArr: [
        { name: "资讯", class: "overall_query_tab_active", count: 2 },
        { name: "赛事", class: "", count: 3 },
        { name: "会议", class: "", count: 1 },
        { name: "课程", class: "", count: 3 },
        { name: "图片", class: "", count: 31 },
        { name: "音乐", class: "", count: 32 },
      ],
    };
  },
  components: {
    BannerBg,
    NewsListItem
  },
  methods: {
    handleSingleQueryTabClick(val) {},
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    overallquerytabClick(index, item) {
      if (item.class != "") {
        return;
      }
      this.overallquerytabsArr.some((ele) => {
        if (ele.class != "") {
          ele.class = "";
        }
      });
      this.overallquerytabsArr[index].class = "overall_query_tab_active";
    },
    contentTabClick(index, item) {
      if (item.class != "") {
        return;
      }
      this.contenttabArr.some((ele) => {
        if (ele.class != "") {
          ele.class = "";
        }
      });
      this.contenttabArr[index].class = "content_tab_active";
    },
  },
};
</script>
<style lang="scss" scoped>
.container_wrap {
  width: 1200px;
  margin: 0 auto;
}
.infoquery {
  min-height: 1239px;
  background: #f8f8f8;
  overflow: hidden;
}
.infoquery_content {
  margin-bottom: 20px;
  margin-top: -123px;
  position: relative;
  z-index: 3;
  .content_tabs {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    .content_tab {
      width: 400px;
      box-sizing: border-box;
      height: 84px;
      background: #eeeeee;
      border-right: 1px solid #fff;
      font-size: 22px;
      font-weight: 400;
      color: #000000;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      &:hover {
        cursor: pointer;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
      }
      &:last-child {
        border-right: none;
      }
    }
    .content_tab_active {
      width: 400px;
      height: 94px;
      background: #ffffff;
      box-shadow: 4px -4px 4px 0px rgba(0, 0, 0, 0.2);
      border-right: none;
    }
  }
  .content_show {
    min-height: 753px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  }
}
.single_query {
  display: flex;
  flex-direction: row;
  .single_query_img {
    width: 497px;
    height: 247px;
    object-fit: cover;
    margin: 117px 146px 0 87px;
  }
  .eltabs {
    width: 422px;
    margin-top: 58px;
    /deep/.el-tabs__nav {
      width: 100%;
      text-align: center;
    }
    /deep/.el-tabs__item {
      font-size: 16px;
      color: #999999;
      &:hover {
        color: #000;
      }
    }
    /deep/.el-tabs__item.is-active {
      color: #000;
    }
    /deep/.el-tabs__active-bar {
      left: 30.2%;
    }
    /deep/.el-tabs__content {
      margin-top: 47px;
    }
    /deep/.el-button {
      width: 95px;
      height: 40px;
    }
  }
}
.overall_query {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 43px 0 0 67px;
  .overall_query_search {
    display: flex;
    flex-direction: row;
    .elinput {
      width: 360px;
      height: 60px;
      line-height: 60px;
      margin-right: 13px;
      /deep/.el-input__inner {
        height: 60px;
      }
    }
    .overall_query_search_but {
      width: 180px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #0486fe;
      border-radius: 6px;

      font-size: 21px;
      font-weight: 400;
      color: #ffffff;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
  .overall_query_tabs {
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    display: flex;
    flex-direction: row;
    margin: 42px 0 50px 0;
    .overall_query_tab {
      margin-right: 40px;
      &:hover {
        cursor: pointer;
        color: #000000;
        &::after {
          content: "";
          display: block;
          width: 17px;
          height: 4px;
          background: #0091ff;
          border-radius: 3px;
          margin: 0 auto;
        }
      }
    }
    .overall_query_tab_active {
      color: #000000;
      &::after {
        content: "";
        display: block;
        width: 17px;
        height: 4px;
        background: #0091ff;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
  }
  .overall_query_content {
  }
}
</style>


// WEBPACK FOOTER //
// InfoQuery.vue?173933c1